import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { UploadCloud, X, Loader2 } from "lucide-react";

export function ImageUploader({ value, onChange, testid = "featured-image" }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp,image/gif" onChange={onFile} className="hidden" data-testid={`${testid}-input`} />
      {value ? (
        <div className="relative inline-block">
          <img src={value} alt="Selected" className="h-40 w-auto max-w-full rounded-xl border border-champagne/40 object-cover" data-testid={`${testid}-preview`} />
          <button
            type="button"
            onClick={() => onChange("")}
            data-testid={`${testid}-remove`}
            className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-ink text-ivory shadow-md hover:bg-destructive transition-colors"
            title="Remove image"
          >
            <X size={14} />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          data-testid={`${testid}-btn`}
          className="flex w-full items-center justify-center gap-2 rounded-xl border-2 border-dashed border-champagne/50 bg-white px-4 py-8 font-body text-sm text-ink/60 hover:border-bronze hover:text-bronze transition-colors disabled:opacity-60"
        >
          {uploading ? <Loader2 size={18} className="animate-spin" /> : <UploadCloud size={18} />}
          {uploading ? "Uploading…" : "Upload an image (JPG, PNG, WEBP, GIF · max 8 MB)"}
        </button>
      )}
    </div>
  );
}
